import { render, staticRenderFns } from "./AudioResources.vue?vue&type=template&id=30c7adb0&scoped=true"
import script from "./AudioResources.vue?vue&type=script&lang=js"
export * from "./AudioResources.vue?vue&type=script&lang=js"
import style0 from "./AudioResources.vue?vue&type=style&index=0&id=30c7adb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c7adb0",
  null
  
)

export default component.exports